// extracted by mini-css-extract-plugin
export var container = "TourMain-module--container--4BcWE";
export var main = "TourMain-module--main--Xlktf";
export var textContainer = "TourMain-module--textContainer--2fpGw";
export var space = "TourMain-module--space--3jrcC";
export var imageContainer = "TourMain-module--imageContainer--NfSQq";
export var noImage = "TourMain-module--noImage--nAMsl";
export var image = "TourMain-module--image--Rk_UO";
export var imageLine = "TourMain-module--imageLine--1jarN";